import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api, getAddressOfOrder } from "ticketino-api-client";

import Header from "./components/Header";
import Footer from "./components/Footer";

const INTEREST_OPTIONS = [
    "Alternative Investments", "Commodities", "Company Pension Plans", "Crypto", "Digital Assets", "Equities", "ESG / Sustainability / Impact Investing",
    "Fintec", "Fixed Income / Convertibles", "Hedge Funds", "Insurance Products", "Investment Strategies", "Passive Instruments / ETF/ ETP", "Politics / Economics",
    "Private Markets", "Real Estate / Mortgages / Infrastructure", "Regulation / Fund Services", "Structured Products"
];

const Step20_Interests = () => {
    const [order, setOrder] = useState({});
    const [orderId, setOrderId] = useState();
    const [organizerId, setOrganizerId] = useState(0);

    const [selectedInterests, setSelectedInterests] = useState([]);
    const [otherInterest, setOtherInterest] = useState("");
    const [resources, setResources] = useState({});

    const [buyerInfo, setBuyerInfo] = useState({
        code2: "",
    });

    // react hook for navigation
    let navigate = useNavigate();

    // base url
    let baseUrl = process.env.REACT_APP_BASEURL_API;

    // setting the base url of the npm package api calls
    api.defaults.baseURL = baseUrl;

    // fetching params
    let { language } = useParams();

    let languageId = 0;

    // changing languageId according to the url
    switch (language) {
        case ("de" || "DE"):
            languageId = 1;
            break;
        case ("fr" || "FR"):
            languageId = 2;
            break;
        case ("en" || "EN"):
            languageId = 3;
            break;
        default:
            languageId = 0;
            language = "de";
            break;
    }

    const isNextDisabled =
        selectedInterests.length === 0 ||
        (selectedInterests.includes("Other") && otherInterest.trim() === "");

    useEffect(() => {
        const loadToken = async () => {
            try {
                const res = await axios.get("form/token");
                axios.defaults.headers.common["Authorization"] = "Bearer " + res.data;
                api.defaults.headers.common['Authorization'] = "Bearer " + res.data;
                await sessionStorage.setItem("token", res.data);

                requestFormSettings();
            } catch (error) {
                console.error(error);
            }
        };

        let currentOrderId = sessionStorage.getItem("OrderId");

        if (currentOrderId > 0) {
            setOrderId(currentOrderId);
        }

        const requestFormSettings = async () => {
            try {
                const res = await axios.get(`form/formsettings`);

                if (currentOrderId > 0) {
                    loadOrder(currentOrderId);
                } else {
                    sessionStorage.removeItem("addedPromotion"); // clear promotion code
                    navigate("/en/home");
                }

                setOrganizerId(res.data.organizerId)
            } catch (error) {
                console.error(error);
            }
        };

        loadToken();
    }, []);

    useEffect(() => {
        requestResources();
    }, [language]); //everytime language is changed

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data?.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    const getOrderByOrderId = async (orderId) => {
        try {
            const res = await axios.get(`${baseUrl}/ShopBasket/Order/${orderId}`);
            return res.data;
        }
        catch (error) {
            console.error(error);
            if (error.response.status === 404 || error.response.status === 403) {
                navigate("/en/home");
            }
        }
    }

    const loadOrder = async (orderId) => {
        try {
            // Order
            const updatedOrder = await getOrderByOrderId(orderId);

            if (updatedOrder === null) {
                navigate("/en/home")
            }

            setOrder(updatedOrder);
        }
        catch (error) {
            console.error(error);
        }
    }

    const handleInterestChange = (interest) => {
        setSelectedInterests((prev) =>
            prev.includes(interest)
                ? prev.filter((i) => i !== interest)
                : [...prev, interest]
        );
    };

    const handleOtherCheckbox = () => {
        if (selectedInterests.includes("Other")) {
            setSelectedInterests(selectedInterests.filter(i => i !== "Other"));
            setOtherInterest("");
        } else {
            setSelectedInterests([...selectedInterests, "Other"]);
        }
    };

    const handleOtherInput = (e) => {
        setOtherInterest(e.target.value);
    };

    const onSubmit = async () => {
        let interestsToStore = selectedInterests.filter(i => i !== "Other");
        if (selectedInterests.includes("Other") && otherInterest.trim() !== "") {
            interestsToStore.push("other: " + otherInterest.trim());
        }
        const updatedBuyerInfo = { ...buyerInfo, interests: interestsToStore.join(",") };
        setBuyerInfo(updatedBuyerInfo);
        await addAddressToBasket(updatedBuyerInfo);
    }

    const addAddressToBasket = async (buyerInfoToSend = buyerInfo) => {
        // Retrieve existing addressBody from localStorage
        let existingAddressBody = {};
        try {
            existingAddressBody = JSON.parse(localStorage.getItem("addressBodySwissFitechWeek")) || {};
        } catch (e) {
            existingAddressBody = {};
        }

        // Merge new fields with existing ones
        let addressBody = {
            ...existingAddressBody,
            code2: buyerInfoToSend.interests, // store all selected interests in one field
        };

        // Save updated addressBody to localStorage
        localStorage.setItem("addressBodySwissFitechWeek", JSON.stringify(addressBody));

        // Navigate to the next step
        navigate(`/${language}/participants`);
    };

    return (
        <>
            <Header />

            <div className="container pt-0 wrapper-smaller">

                <div className="row mt-5">
                    <div className="col-md-12">
                        <span className="title">TOPICS OF INTEREST</span><br />
                        <span className="text-muted">Multiple selections possible</span>
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-md-6">
                        {/* Interests checkboxes */}
                        <div>
                            {INTEREST_OPTIONS.map((interest, idx) => (
                                <label
                                    key={idx}
                                    className={`d-flex align-items-center mb-2${selectedInterests.includes(interest) ? ' selected-interest' : ''}`}
                                    style={{ cursor: "pointer" }}
                                >
                                    <input
                                        type="checkbox"
                                        checked={selectedInterests.includes(interest)}
                                        onChange={() => handleInterestChange(interest)}
                                        className="d-none"
                                    />
                                    <i className={`bi bi${selectedInterests.includes(interest) ? "-check" : ""}-square me-2`}></i>
                                    <span>{interest}</span>
                                </label>
                            ))}
                            {/* Other checkbox */}
                            <label
                                className={`d-flex align-items-center mb-2${selectedInterests.includes("Other") ? ' selected-interest' : ''}`}
                                style={{ cursor: "pointer" }}
                            >
                                <input
                                    type="checkbox"
                                    checked={selectedInterests.includes("Other")}
                                    onChange={handleOtherCheckbox}
                                    className="d-none"
                                />
                                <i className={`bi bi${selectedInterests.includes("Other") ? "-check" : ""}-square me-2`}></i>
                                <span>Other:</span>
                                <input
                                    type="text"
                                    className="form-control ms-2"
                                    style={{ maxWidth: 230, height: "35px" }}
                                    value={otherInterest}
                                    onChange={handleOtherInput}
                                    disabled={!selectedInterests.includes("Other")}
                                />
                            </label>
                        </div>
                    </div>
                </div>

                <div className="row mt-5">
                    <div className="col-md-6">
                        <button className="btn btn-custom" onClick={() => navigate(-1)}>{resources?._Back}</button>
                    </div>
                    <div className="col-md-6 text-end">
                        <button className="btn btn-custom" onClick={() => onSubmit()} disabled={isNextDisabled}>{resources?._Next}</button>
                    </div>
                </div>
            </div>

            <div className="container wrapper">
                <div className="col-md-12 pt-4 text-center">
                    <Footer language={language} />
                </div>
            </div>
        </>
    )
}

export default Step20_Interests